export default {
  path: '/forgot-password',
  name: 'ForgotPassword',
  component: () => import(/* webpackChunkName: "forgot-password" */ '../../views/ForgotPassword.vue'),
};
